import { render, staticRenderFns } from "./DataItem.vue?vue&type=template&id=3ba7ea02&scoped=true&lang=html&"
import script from "./DataItem.vue?vue&type=script&lang=js&"
export * from "./DataItem.vue?vue&type=script&lang=js&"
import style0 from "./DataItem.vue?vue&type=style&index=0&id=3ba7ea02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba7ea02",
  null
  
)

export default component.exports